import $ from 'jquery';
import { Component } from 'react';

class CompanyComparison extends Component {
  constructor() {
    super();
    this.tooltipId = 'company-helper-text';
  }

  componentDidMount() {
    $(`#${this.tooltipId}`).tooltip({ html: true, title: this.props.help });
  }

  render() {
    let headlineStyle = {
      fontSize: this.props.value ? 25 : null,
    };
    return (
      <div className="status-block">
        <div
          className="status-block__status spec-company-comparison"
          style={headlineStyle}
        >
          {this.props.value || 'N/A'}
        </div>
        <div className="status-block__title">
          {this.props.label}{' '}
          <i
            id={this.tooltipId}
            data-toggle="tooltip"
            className="fa fa-question-circle"
          />
        </div>
      </div>
    );
  }
}

export default CompanyComparison;
